function fn_comp_about() {
    var $fn = $(".comp_about"),
        $wrp_comp_content = $fn.find(".wrp_comp_content");

    function fn_comp_about_wrp_block_col() {
        $wrp_comp_content.find(".wrp_block").css("margin-bottom","").children(".col").css({"margin-bottom":"","transform": ""});
        if ($(window).width() > 960) {
            $wrp_comp_content.find(".wrp_block").each(function(){
                var $elm = $(this),
                    $size = $elm.children().eq(0).height() - $elm.children().eq(1).height();
                if ($elm.children().eq(0).height() !== $elm.children().eq(1).height() && $size > 0) {
                    $elm.closest(".wrp_block").next().css("margin-bottom","-"+$size+"px").children().eq(0).css("margin-bottom",$size+"px").next().css("transform","translate(0,-"+$size+"px)");
                }
            });
        }
    }

    setTimeout(function(){
        fn_comp_about_wrp_block_col();
    },300);

    $(window).resize(fn_comp_about_wrp_block_col);
}